// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__js7Dt","left":"styles_left__2FdxQ"};